<template>
  <div class="client-row">
    <label for="aiModel" class="col-3">AI Toolset</label>
    <div class="col-9 d-flex pl-0">
      <div class="col-3 m-0 p-0 d-flex">
        <select id="aiModel" name="aiModel" v-model="localValue" class="form-control w-100" :disabled="disabled" @change="saveAIToolset">
            <option :value="0">None</option>
            <option v-for="(ai_type_option, idxAiTypeOptions) in ai_type_options" v-bind:value="ai_type_option.aiTypeId" v-bind:key="idxAiTypeOptions">
            {{ ai_type_option.displayName }}
            </option>
        </select>
      </div>
      <div class="col-6 ml-1">
        <button type="button" class="btn btn-primary" :disabled="this.inputClientCode == ''" @click="openApplyAIToolsetToClientHierarchy">Apply to Client Hierarchy</button>
      </div>
    </div>
    <modal
      :modal-id="'Apply to Client Hierarchy For AI Toolset'"
      :modal-title="'Apply to Client Hierarchy'"
      :modal-content="'Are you sure you want apply AI Toolset to all organizations in this hierarchy ?'"
      :include-confirmation="true"
      @confirm="applyAIToolsetToClientHierarchy"
    />
  </div>
</template>
<script>
import AIService from "../services/ai.service";
import AdminService  from "../services/admin.service";
import ViewMixins from "../mixins/ViewMixins.vue";
export default {
  name: "AiTypes",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
        ai_type_options: [],
        localValue: 0
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    inputClientCode: {
      type: String,
      default: ""
    },
  },
  computed: {
    
  },
  mounted() {
    
  },
  created() {
    AIService.getAllAITypes(this.loadAITypes);
  },
  methods: {
    loadAITypes(response) {
      this.ai_type_options = response;
    },
    normalize(val) {
      return val === null || val === undefined ? 0 : Number(val);
    },
    saveAIToolset(withHierarchy = false) {
      if (withHierarchy === true){
          this.$root.processServerRequest("Saving AI Toolset for hierarchy");        
      } else {
          this.$root.processServerRequest("Saving AI Toolset");        
      }     
      AIService.saveAIToolsetToClient(this.inputClientCode, this.localValue, this.applyToHierarchy, this.saveAIToolsetCallback, this)
    },
    openApplyAIToolsetToClientHierarchy: function(){
      this.applyToHierarchy = 'Y';
      this.$modal.show("Apply to Client Hierarchy For AI Toolset");
    },
    applyAIToolsetToClientHierarchy: function(){
      this.applyToHierarchy = 'Y';
      this.saveAIToolset(true);
    },
    saveAIToolsetCallback: function(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
      this.applyToHierarchy = 'N';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.localValue = this.normalize(val);
      }
    },

    // localValue(val) {
    //   this.$emit("input", this.normalize(val));
    // }
  },
};
</script>
